import React, { useState, useRef, useEffect } from "react";
import "./index.css"; // External CSS file\imp
import store from "store";
import { imageMediaUrl } from "../../util/config";
import { Link } from "react-router-dom";
import CircularProgress from "../../components/CircularProgress";

const TraineeLeaderboard = () => {
  const [leaderboardData, setLeaderBoard] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [currentPage, setCurrentPage] = useState(1);
  const [first, setFirst] = useState("");
  const [second, setSecond] = useState("");
  const [third, setThird] = useState("");
  const [userRank, setUserRank] = useState(0);
  const [allUsers, setTotalUsers] = useState();

  const usersPerPage = 10;
  const visiblePages = 5;
  const half = Math.floor(visiblePages / 2);

  let start = Math.max(currentPage - half, 1);
  let end = Math.min(start + visiblePages - 1, totalPages);

  // Adjust start if near the end
  if (end - start < visiblePages - 1) {
    start = Math.max(end - visiblePages + 1, 1);
  }

  // Calculate pagination
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = leaderboardData.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(leaderboardData.length / usersPerPage);

  const goToPage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Placeholder user avatar image
  const avatarUrl =
    "https://storage.googleapis.com/workspace-0f70711f-8b4e-4d94-86f1-2a93ccde5887/image/134ed1bc-85a6-4f78-9b1f-fab0728ce9b3.png";

  let userInfo = store.get("user");
  const getLeaderBoard = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const url = apiUrl + "api/trainee/getLeaderBoard";
    const accessToken = localStorage.getItem("accessToken");

    const params = new URLSearchParams({ page: 0 });

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds

    try {
      const res = await fetch(url + "?" + params.toString(), {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        if (res.status === 401) {
          if (window.message && window.message.error) {
            window.message.error(
              "Your session has been expired. Please relogin."
            );
          }
          localStorage.clear();
          window.location.reload();
          throw new Error("Session expired");
        } else {
          if (window.message && window.message.error) {
            window.message.error("Some error has occurred.");
          }
          throw new Error("API error");
        }
      }

      const response = await res.json();

      console.log(response.data[0].userName, "Result here");
      setLeaderBoard(response.data || []);

      const userWithPosition1 = response.data.find(
        (user) => user.position === 1
      );
      if (userWithPosition1) {
        setFirst(userWithPosition1.userName);
      }

      const userWithPosition2 = response.data.find(
        (user) => user.position === 2
      );
      if (userWithPosition2) {
        setSecond(userWithPosition2.userName);
      }

      const userWithPosition3 = response.data.find(
        (user) => user.position === 3
      );
      if (userWithPosition3) {
        setThird(userWithPosition3.userName);
      }

      setTotalUsers(response.totalRecord);
      setUserRank(response.userRank);
    } catch (err) {
      clearTimeout(timeoutId);

      if (err.name === "AbortError") {
        if (window.message && window.message.error) {
          window.message.error("Request timed out. Please try again later.");
        }
      } else if (
        err.message !== "Session expired" &&
        err.message !== "API error"
      ) {
        if (window.message && window.message.error) {
          window.message.error("Some error has occurred.");
        }
      }

      console.error("Failed to fetch trainee trainings:", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getLeaderBoard();
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      <div
        className="welcome-section-leaderboard"
        style={{ backgroundColor: "#F5F5F5" }}
      >
        <h2 style={{ textAlign: "center" }} className="sub-title">
          Leaderboard
        </h2>
      </div>
      {loading ? (
        <CircularProgress></CircularProgress>
      ) : (
        <div style={{ backgroundColor: "#F5F5F5" }}>
          <div className="centre-box">
            <div className="gradient-box">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "flex-end", // align medals along bottom
                  height: "335px",
                }}
              >
                {/* Silver */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginLeft: "101px",
                    marginTop: "261px",
                  }}
                >
                  <img
                    src="/assets/userProfile.png"
                    style={{
                      width: "100px",
                      marginBottom: "-45px",
                    }}
                  />
                  <h4 style={{ color: "#ffffff" }}>{second}</h4>
                  <img
                    src="/assets/silver.png"
                    style={{
                      width: "200px",
                    }}
                  />
                </div>

                {/* Gold */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "205px",
                  }}
                >
                  <img
                    src="/assets/userProfile.png"
                    style={{
                      width: "100px",
                      marginBottom: "-45px",
                    }}
                  />
                  <h4 style={{ color: "#ffffff" }}>{first}</h4>

                  <img
                    src="/assets/gold.png"
                    style={{
                      width: "200px",
                    }}
                  />
                </div>

                {/* Bronze */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginRight: "122px",
                    marginTop: "306px",
                  }}
                >
                  <img
                    src="/assets/userProfile.png"
                    style={{
                      width: "100px",
                      marginBottom: "-45px",
                    }}
                  />
                  <h4 style={{ color: "#ffffff" }}>{third}</h4>

                  <img
                    src="/assets/bronze.png"
                    style={{
                      width: "200px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="leaderboard-container">
            <div className="leaderboard-header">
              Your rank is <strong>{userRank}</strong> out of{" "}
              <strong>{allUsers}</strong> users
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <div className="pagination">
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{ fontSize: "18px", marginRight: "8px" }}
                >
                  ◀
                </button>
                <span style={{ margin: "11px 8px" }}>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{ fontSize: "18px", marginLeft: "8px" }}
                >
                  ▶
                </button>
              </div>
            </div>

            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th style={{ textAlign: "left" }}>User name</th>
                  <th>Email</th>

                  <th>Risk Score</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.map((user, index) => (
                  <tr
                    key={index}
                    style={{ backgroundColor: "#fff3cd" }}
                    className={`${index % 2 === 0 ? "even" : "odd"} ${
                      index === 0 && currentPage === 1 ? "highlight" : ""
                    }`}
                  >
                    <td>{user.position}</td>
                    <td className="user-cell">
                      <img
                        className="avatar"
                        src={"/assets/leaderboardProfile.png"}
                        alt=""
                      />
                      {currentPage === 1 && index === 0 ? "You" : user.userName}
                    </td>
                    <td>{user.email}</td>
                    <td>{user.riskScore}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default TraineeLeaderboard;
